/**
 * @description: Application Model.
 * @requires {Object} $cookies
 */
function applicationModel($cookies) {

  /* @ngInject */
  const trackingDetails = {};
  const estimatedDelivery = {};

  /**
   * @description: Checks the cookie and sets the sessionToken in the application model.
   */
  function checkSessionToken() {

    // TODO remove the x-recaptcha-session once APIm deploys 3.2.
    const sessionCookie = $cookies.get('X-RMG-API-Session') || $cookies.get('x-recaptcha-session');

    if (sessionCookie !== undefined && sessionCookie !== null && sessionCookie !== 'null') {

      return sessionCookie;

    }

    return null;

  }

  return {
    trackingDetails: trackingDetails,
    estimatedDelivery: estimatedDelivery,
    urlRefresh: true,
    urlRequest: {},
    googleRecaptcha: {
      sessionToken: checkSessionToken()
    },
    authToken: null
  };

}

export default applicationModel;



// WEBPACK FOOTER //
// ./src/services/model.service.js